var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-express"},[_c('div',{staticClass:"express-tag"},_vm._l((_vm.common),function(item){return _c('span',{key:item.id,class:{ checked: item.id === _vm.express },on:{"click":function($event){return _vm.handleChange(item.id)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }